import { TourTripDataOutput } from './tour-trip-data-output.model';


export class TourAllocationOutputWithOutStatus implements ITourAllocationOutputWithOutStatus {
    /** The auto generated id from tour allocation master */
    tour_allocation_id!: number;
    /** The auto-generated id of the tour master */
    tour_id!: number;
    /** The auto generated id from company details master */
    company_details_id!: number;
    /** The auto generated id from branch details master */
    branch_detail_id!: number;
    /** The auto generated id from vehicle details master */
    vehicle_details_id!: number;
    /** The tour schedule type  should be Relative, Fixed or Automatic */
    tour_schedule_type!: string;
    /** The tour schedule should be Daily,Weekly,Monthly */
    schedule!: string;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    sunday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    monday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    tuesday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    wednesday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    thursday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    friday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    saturday!: number;
    /** The days */
    days!: number;
    /** The  trip start time 20 character limit */
    trip_start_time!: string;
    /** The valid from 20 character limit */
    valid_from!: string;
    /** The valid to 20 character limit */
    valid_to!: string;
    tour_trip_timing!: TourTripDataOutput[];
    status!: number;

    constructor(data?: ITourAllocationOutputWithOutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tour_allocation_id = _data["tour_allocation_id"];
            this.tour_id = _data["tour_id"];
            this.company_details_id = _data["company_details_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.tour_schedule_type = _data["tour_schedule_type"];
            this.schedule = _data["schedule"];
            this.sunday = _data["sunday"];
            this.monday = _data["monday"];
            this.tuesday = _data["tuesday"];
            this.wednesday = _data["wednesday"];
            this.thursday = _data["thursday"];
            this.friday = _data["friday"];
            this.saturday = _data["saturday"];
            this.days = _data["days"];
            this.trip_start_time = _data["trip_start_time"];
            this.valid_from = _data["valid_from"];
            this.valid_to = _data["valid_to"];
            if (Array.isArray(_data["tour_trip_timing"])) {
                this.tour_trip_timing = [] as any;
                for (let item of _data["tour_trip_timing"])
                    this.tour_trip_timing!.push(TourTripDataOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TourAllocationOutputWithOutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TourAllocationOutputWithOutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tour_allocation_id"] = this.tour_allocation_id;
        data["tour_id"] = this.tour_id;
        data["company_details_id"] = this.company_details_id;
        data["branch_detail_id"] = this.branch_detail_id;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["tour_schedule_type"] = this.tour_schedule_type;
        data["schedule"] = this.schedule;
        data["sunday"] = this.sunday;
        data["monday"] = this.monday;
        data["tuesday"] = this.tuesday;
        data["wednesday"] = this.wednesday;
        data["thursday"] = this.thursday;
        data["friday"] = this.friday;
        data["saturday"] = this.saturday;
        data["days"] = this.days;
        data["trip_start_time"] = this.trip_start_time;
        data["valid_from"] = this.valid_from;
        data["valid_to"] = this.valid_to;
        if (Array.isArray(this.tour_trip_timing)) {
            data["tour_trip_timing"] = [];
            for (let item of this.tour_trip_timing)
                data["tour_trip_timing"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface ITourAllocationOutputWithOutStatus {
    /** The auto generated id from tour allocation master */
    tour_allocation_id: number;
    /** The auto-generated id of the tour master */
    tour_id: number;
    /** The auto generated id from company details master */
    company_details_id: number;
    /** The auto generated id from branch details master */
    branch_detail_id: number;
    /** The auto generated id from vehicle details master */
    vehicle_details_id: number;
    /** The tour schedule type  should be Relative, Fixed or Automatic */
    tour_schedule_type: string;
    /** The tour schedule should be Daily,Weekly,Monthly */
    schedule: string;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    sunday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    monday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    tuesday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    wednesday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    thursday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    friday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    saturday: number;
    /** The days */
    days: number;
    /** The  trip start time 20 character limit */
    trip_start_time: string;
    /** The valid from 20 character limit */
    valid_from: string;
    /** The valid to 20 character limit */
    valid_to: string;
    tour_trip_timing: TourTripDataOutput[];
    status: number;
}

